import { Category } from "../processors";
import React, { useContext } from "react";

interface ICategoryMetaContext {
    categoryLoading?: boolean;
    categories: Category[];
    roots: Category[];
    adminIdToCategory: Record<string, Category>;
    tIdToCategory: Record<number, Category>;
}

const defaultState = {
    categories: [],
    roots: [],
    adminIdToCategory: {},
    tIdToCategory: {},
    categoryLoading: true
};

export const CategoryMetaContext = React.createContext<ICategoryMetaContext>(defaultState);
export const useCategoryMetaContext = () => useContext(CategoryMetaContext);
